import { SsoSingleIntegrationWebComponent } from './component/SsoSingleIntegrationWebComponent';

export { SsoSingleIntegrationWebComponent };
